import { render, staticRenderFns } from "./CategoryTreeItem.vue?vue&type=template&id=07458205"
import script from "./CategoryTreeItem.vue?vue&type=script&lang=js"
export * from "./CategoryTreeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports